class CollapsibleElement extends HTMLElement {
  connectedCallback() {
    this.controller = this.querySelector('[aria-expanded]');
    this.controller.addEventListener('click', this.toggle.bind(this));
  }

  /**
   * find the content element
   */
  findContent() {
    const id = this.controller.getAttribute('aria-controls');
    this.content = document.getElementById(id);
  }

  /**
   * Open the collapsible element
   */
  open() {
    this.findContent();
    this.controller.setAttribute('aria-expanded', 'true');
    this.content.setAttribute('aria-hidden', 'false');
  }

  /**
   * Close the collapsible element
   */
  close() {
    this.findContent();
    this.controller.setAttribute('aria-expanded', 'false');
    this.content.setAttribute('aria-hidden', 'true');
  }

  /**
   * Toggle the collapsible element
   */
  toggle() {
    const isExpanded = this.controller.getAttribute('aria-expanded') === 'true';
    isExpanded ? this.close() : this.open();
  }
}

customElements.define('collapsible-element', CollapsibleElement);
